import React from 'react';
import { Link } from 'react-router-dom';
import { Info } from '@mui/icons-material';

interface LogoProps {
    href?: string;
    link?: string;
    name: string;
}

export const FooterLogo: React.FC<LogoProps> = React.memo(({ href, link, name }) => (
    <>
        {href ? (
            <a
                href={href}
                target='_blank'
                rel='noopener noreferrer'
                className='footer__logos__logo'
            >
                <Info fontSize='small' />
                <p className='footer__logos__logo__name'>{name}</p>
            </a>
        ) : (
            <Link to={link ? link : '/'} className='footer__logos__logo'>
                <Info fontSize='small' />
                <p className='footer__logos__logo__name'>{name}</p>
            </Link>
        )}
    </>
));
